const ua = navigator.userAgent.toLowerCase();
let matched;
const browser = {};

/**
 * Browser type and versions, see <a target='_blank' href='http://api.jquery.com/jQuery.browser/'>jQuery.browser</a>
 * @class browser
 * @namespace lang
 * @module lang
 */

// Use of jQuery.browser is frowned upon.
// More details: http://api.jquery.com/jQuery.browser
// uaMatch maintained for back-compat
const match =
    /(chrome)[ \/]([\w.]+)/.exec(ua) ||
    /(webkit)[ \/]([\w.]+)/.exec(ua) ||
    /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
    /(msie) ([\w.]+)/.exec(ua) ||
    (ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua)) ||
    [];

// ie11 support
// ie11 ua change: http://msdn.microsoft.com/zh-cn/library/ie/hh869301(v=vs.85).aspx
let matchIe11;
if (ua.indexOf('trident') > -1 && (matchIe11 = /rv:([\d.]+)/.exec(ua))) {
    match[1] = 'msie';
    match[2] = matchIe11[1];
}

matched = {
    browser: match[1] || '',
    version: match[2] || '0'
};

if (matched.browser) {
    browser[matched.browser] = true;
    browser.version = matched.version;
}

// Chrome is Webkit, but Webkit is also Safari.
if (browser.chrome) {
    browser.webkit = true;
} else if (browser.webkit) {
    browser.safari = true;
}

const isIE = browser.msie;
const majorVersion = parseInt(browser.version, 10);
/*eslint-disable */

// Mobile detect
let isMobile = (browser.isMobile = ua.match(
    /(nokia|iphone|android|motorola|^mot\-|softbank|foma|docomo|kddi|up\.browser|up\.link|htc|dopod|blazer|netfront|helio|hosin|huawei|noletra|CoolPad|webos|techfaith|palmsource|blackberry|alcatel|amoi|ktouch|nexian|samsung|^sam\-|s[cg]h|^lge|ericsson|philips|sagem|wellcom|bunjalloo|maui|symbian|smartphone|midp|wap|phone|windows ce|iemobile|^spice|^bird|^zte\-|longcos|pantech|gionee|^sie\-|portalmmm|jig\s browser|hiptop|^ucweb|^benq|haier|^lct|opera\s*mobi|opera\*mini|320x320|240x320|176x220)/i
));

/* eslint-enable */
/**
 * Whether it's window
 * @property isWin
 */
browser.isWin = /windows|win32/.test(ua);

/**
 * Whether it's mac
 * @property isMac
 */
browser.isMac = /Mac/.test(ua);

/**
 * Whether it's iOS
 * @property isIOS
 */
browser.isIOS = /(?:iphone|ipad|ipod)/i.test(ua);

/**
 * Whether it's android
 * @property isAndroid
 */
browser.isAndroid = /android/i.test(ua);

/**
 * Browser name
 * @property browser
 */
browser.browser = matched.browser || '';

/**
 * Browser's big version, like IE 9.0.8812.1621, its big version is integer 9
 * @property majorVersion
 */
browser.majorVersion = majorVersion;

/**
 * Whether it's IE or not
 * @property isIE
 */
browser.isIE = isIE;

/**
 * Whether it's IE6 or not
 * @property isIE6
 */
browser.isIE6 = isIE && majorVersion === 6;

/**
 * Whether it's IE9 or not
 * @property isIE9
 */
browser.isIE9 = isIE && majorVersion === 9;

/**
 * Whether it's IE9 or below, including IE6, IE7, IE8
 * @property isIE9Below
 */
browser.isIE9Below = isIE && majorVersion < 9;

browser.isIE10Below = isIE && majorVersion < 10;

browser.isIE11Below = isIE && majorVersion < 11;

browser.isMobile = isMobile;

browser.isGoogleChrome = browser.chrome;

export default browser;
